import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Switch, Route, Redirect, Link, useLocation, NavLink } from "react-router-dom";

import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Divider from '@material-ui/core/Divider';

// Dialog Components
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// Icons
import AccountIcon from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import MembershipIcon from '@material-ui/icons/VerifiedUser';
import PaymentIcon from '@material-ui/icons/Payment';
import PasswordIcon from '@material-ui/icons/Https';
import SettingsIcon from '@material-ui/icons/Settings';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import FlagIcon from '@material-ui/icons/Flag';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';

import ProfileMenu from 'app/components/ProfileMenu';
import Loading from 'app/components/loaders/Loading';
import RedButton from 'app/components/buttons/RedButton';

// Pages
import Profile from 'app/pages/Profile';
import ClubRegistrationForm from 'app/components/auth/registration/ClubRegistrationForm';
import NewClubRegistrationForm from 'app/components/auth/registration/NewClubRegistrationForm';
import FindClubForm from 'app/components/auth/registration/FindClubForm';
import PageNotFound from 'app/pages/PageNotFound';

import useApp from 'app/context/useApp';

const useStyles = makeStyles(theme => ({
    appBar: {
        backgroundColor: '#fff'
    },
    toolbar: {
        minHeight: "50px",
        alignItems: "center",
        justifyContent: "space-between",
        display: "flex",
        flexWrap: "nowrap"
    },
    imgContainer: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    imgLink: {
        lineHeight: 0,
        display: 'block'
    },
    img: {
        height: '70px',
        maxHeight:'70px',
        width: 'auto'
    },
    listItem: {
        width: 'auto',
        display: 'inline-block',
        marginLeft: theme.spacing(2),
        verticalAlign: 'middle'
    },
    listItemContained: {
        width: 'auto',
        display: 'inline-block',
        marginLeft: theme.spacing(3),
        verticalAlign: 'middle'
    },
    buttonWrapper: {
        position: 'relative',
        display: 'inline-block'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    main: {
        paddingTop: 86
    },
    mainAbsolute: {
        position: 'absolute',
        top: 86,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'scroll'
    },
    container: {
        zIndex: 12,
        height: '100%',
    },
    loginContainer: {
        padding: theme.spacing(3),

        [theme.breakpoints.down('xs')]: {
            paddingRight: '0px',
            paddingLeft: '0px',
        }
    },
    loginImage: {
        height: 'auto',
        maxWidth: '320px',
        width: 'auto'
    },
    loginBranding: {
        marginBottom: theme.spacing(2),
        textAlign: 'center'
    },
    paper: {
        padding: theme.spacing(4),
        maxWidth: '680px',
        width: '100%'
    },
    emptyBorderPrimary: {
        border: '2px solid',
        borderColor: "rgb(159, 222, 250)"
    },
    profileButton : {
        marginLeft: theme.spacing(1),
        cursor: 'pointer'
    },
    menuItem: {
        width: 250
      },
}));

export default function HomeLayout(props) {

    const { app } = useApp();
    const classes = useStyles();
    let location = useLocation();
    const theme = useTheme();

    const [ loading, setLoading ] = useState(false);
    const [ profileMenuOpen, setProfileMenuOpen ] = useState(false);
    const [ drawerOpen, setDrawerOpen ] = useState(false);
    const [ verifyLogout, setVerifyLogout ] = useState(false);
    const [ logoutLoading, setLogoutLoading ] = useState(false);

    const profileAnchorRef = useRef(null);
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        setProfileMenuOpen(false);
    }, [location]);

    const handleLoading = value => {
        setLoading(value)
    }

    const handleProfileMenu = () => {
        setProfileMenuOpen((prevOpen) => !prevOpen)
    }

    const handleProfileMenuClose = () => {
        setProfileMenuOpen(false)
    }

    const handleVerifyLogout = () => {
        setVerifyLogout(true);
    }

    const handleLogoutCancel = () => {
        setVerifyLogout(false);
    }

    const handleLogout = () => {

        setLogoutLoading(true);

        const bearerToken = api.defaults.headers.common['Authorization'];
        const token = bearerToken.substr(bearerToken.indexOf(" ") + 1);

        api.delete('/oauth/token/' + token).catch(() => setLogoutLoading(false));
    };

    const toggleDrawer = (opener) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }

        setDrawerOpen(opener)
      };

    return (
            <>
                <AppBar className={classes.appBar} position="fixed">
                    <Toolbar className={classes.toolbar}>
                        {mobile ? (
                            <>
                                <div className={classes.imgContainer}>
                                    <Link to="/" className={classes.imgLink}>
                                        <img
                                            className={classes.img}
                                            title="Welcome to Club Apps"
                                            src={process.env.MIX_ICON}/>
                                    </Link>
                                </div>
                                <div>
                                    <MenuIcon
                                        color='primary'
                                        size='large'
                                        onClick={toggleDrawer(true)}
                                    />
                                    <SwipeableDrawer
                                        anchor='right'
                                        open={drawerOpen}
                                        onClose={toggleDrawer(false)}
                                        onOpen={toggleDrawer(true)}
                                    >
                                        <MenuList
                                            className={classes.menuItem}
                                        >
                                            {(app.user.active_club) &&
                                                <MenuItem dense >
                                                    <Button
                                                        fullWidth
                                                        href={app.user.active_club.url}
                                                        color="primary"
                                                        startIcon={<FlagIcon />}
                                                        variant="contained"
                                                        onClick={toggleDrawer(false)}
                                                        >
                                                        {app.user.active_club.name}
                                                    </Button>
                                                </MenuItem>
                                            }
                                            <MenuItem
                                                dense
                                                button
                                                to="/register/club/new"
                                                component={NavLink}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemIcon>
                                                    <AddIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="New Organization" />
                                            </MenuItem>
                                            <MenuItem
                                                dense
                                                button
                                                to="/register/club/find"
                                                component={NavLink}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemIcon>
                                                    <SearchIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Find An Organization" />
                                            </MenuItem>
                                            <Divider />
                                            <MenuItem
                                                dense
                                                button
                                                to='/profile'
                                                component={NavLink}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemIcon>
                                                    <AccountIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="My Profile" />
                                            </MenuItem>
                                            <MenuItem
                                                to="/profile/clubs"
                                                dense
                                                button
                                                component={NavLink}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemIcon>
                                                    <MembershipIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="My Organizations" />
                                            </MenuItem>
                                            <MenuItem
                                                to="/profile/payment"
                                                dense
                                                button
                                                component={NavLink}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemIcon>
                                                    <PaymentIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Payments" />
                                            </MenuItem>
                                            <MenuItem
                                                to="/profile/security"
                                                dense
                                                button
                                                component={NavLink}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemIcon>
                                                    <PasswordIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Security" />
                                            </MenuItem>
                                            <MenuItem
                                                to="/profile/settings"
                                                dense
                                                button
                                                component={NavLink}
                                                onClick={toggleDrawer(false)}
                                            >
                                                <ListItemIcon>
                                                    <SettingsIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Settings" />
                                            </MenuItem>
                                            <Divider/>
                                            <MenuItem
                                                dense
                                                button
                                                onClick={handleVerifyLogout}
                                            >
                                                <ListItemIcon>
                                                    <LogoutIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Logout" />
                                            </MenuItem>
                                        </MenuList>
                                    </SwipeableDrawer>
                                </div>
                            </>
                        ) : (
                            <>
                            <div className={classes.imgContainer}>
                                <Link to="/" className={classes.imgLink}>
                                    <img
                                        className={classes.img}
                                        title="Welcome to Club Apps"
                                        src={process.env.MIX_ICON}/>
                                </Link>
                            </div>
                            <List>
                                {/* <ListItem disableGutters className={classes.listItem}>
                                    <Button
                                        component={Link}
                                        to={"/feed"}
                                        color="primary"
                                        >
                                        News Feed
                                    </Button>
                                </ListItem> */}

                                <ListItem disableGutters className={classes.listItem}>
                                    <Button
                                        component={Link}
                                        to={"/register/club/new"}
                                        color="secondary"
                                        >
                                        New Organization
                                    </Button>
                                </ListItem>
                                <ListItem disableGutters className={classes.listItem}>
                                    <Button
                                        component={Link}
                                        to={"/register/club/find"}
                                        color="secondary"
                                        >
                                        Find Organization
                                    </Button>
                                </ListItem>
                                {(app.user.active_club) &&
                                    <ListItem disableGutters className={classes.listItemContained}>
                                        <Button
                                            href={app.user.active_club.url}
                                            color="secondary"
                                            variant="contained"
                                            >
                                            {app.user.active_club.name}
                                        </Button>
                                    </ListItem>
                                }
                                <ListItem disableGutters className={classes.listItemContained}>
                                    <ListItemAvatar>
                                        { (app.user.avatar) ? (
                                            <Avatar
                                                alt={app.user.full_name}
                                                src={app.user.avatar}
                                                aria-controls={profileMenuOpen ? 'profile-menu' : undefined}
                                                aria-haspopup="true"
                                                onClick={handleProfileMenu}
                                                ref={profileAnchorRef}
                                                className={classes.profileButton}
                                            />
                                        ) : (
                                            <IconButton
                                                aria-controls={profileMenuOpen ? 'profile-menu' : undefined}
                                                aria-haspopup="true"
                                                onClick={handleProfileMenu}
                                                ref={profileAnchorRef}
                                                className={classes.profileButton}
                                                color="primary"
                                                size="small"
                                                >
                                                    <AccountIcon fontSize="large"/>
                                            </IconButton>
                                        )}
                                    </ListItemAvatar>
                                </ListItem>
                            </List>
                            </>
                        )}
                    </Toolbar>
                </AppBar>
                <ProfileMenu
                    open={profileMenuOpen}
                    anchorRef={profileAnchorRef}
                    onClose={handleProfileMenuClose}
                />
                <main className={classes.mainAbsolute}>
                    <Switch>
                        {/*}
                        <Route path="/feed" exact>
                            <Feed app={app} />
                        </Route>
                        */}
                        <Route path="/profile">
                            <Profile app={app}/>
                        </Route>
                        <Route path={'/register/club'} exact>
                            <Grid container alignItems="center" justify="center" className={classes.container}>
                                <Grid item className={classes.loginContainer}>
                                    { loading ? (
                                        <LinearProgress />
                                    ) : (
                                        <div className={classes.emptyBorderPrimary}/>
                                    )}
                                    <Paper className={classes.paper}>
                                        <div className={classes.loginBranding}>
                                            <img
                                                className={classes.loginImage}
                                                src={process.env.MIX_BRANDING}
                                                alt="Welcome to Club Apps"
                                                />
                                        </div>
                                        <ClubRegistrationForm onLoading={handleLoading}/>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Route>
                        <Route path={'/register/club/new'} exact>
                            <Grid container alignItems="center" justify="center" className={classes.container}>
                                <Grid item className={classes.loginContainer}>
                                    { loading ? (
                                        <LinearProgress />
                                    ) : (
                                        <div className={classes.emptyBorderPrimary}/>
                                    )}
                                    <Paper className={classes.paper}>
                                        <div className={classes.loginBranding}>
                                            <img
                                                className={classes.loginImage}
                                                src={process.env.MIX_BRANDING}
                                                alt="Welcome to Club Apps"
                                                />
                                        </div>
                                        <NewClubRegistrationForm user={app.user} onLoading={handleLoading} loading={loading}/>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Route>
                        <Route path={'/register/club/find'} exact>
                            <Grid container alignItems="center" justify="center" className={classes.container}>
                                <Grid item className={classes.loginContainer}>
                                    { loading ? (
                                        <LinearProgress />
                                    ) : (
                                        <div className={classes.emptyBorderPrimary}/>
                                    )}
                                    <Paper className={classes.paper}>
                                        <FindClubForm onLoading={handleLoading} loading={loading}/>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Route>

                        <Route path='/404'>
                            <PageNotFound/>
                        </Route>
                        <Redirect exact from="/" to="/register/club" />
                        <Redirect exact from="/register" to="/register/club" />
                        <Redirect from="/login" to="/register/club" />
                        <Redirect exact from="/feed" to="/register/club" />
                        <Redirect exact from="/password/reset" to="/register/club" />
                        <Redirect to="/404" />
                    </Switch>
                    <Dialog
                        open={verifyLogout}
                        onClose={handleLogoutCancel}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        >
                        <Loading isLoading={logoutLoading}/>
                        <DialogTitle id="alert-dialog-title">Confirm you want to logout</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure you want to logout? You will be directed back to the login screen.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleLogoutCancel} color="primary" autoFocus>
                                Cancel
                            </Button>
                            <RedButton onClick={handleLogout} variant="contained">
                                Logout
                            </RedButton>
                        </DialogActions>
                    </Dialog>
                </main>
            </>
    )
};
